import { Check, ChevronDown } from "lucide-react";

const TONES = [
  { value: "diplomatic", label: "Diplomatic", desc: "Tactful, solution-oriented", color: "text-blue-600" },
  { value: "casual", label: "Casual", desc: "Friendly, conversational", color: "text-green-600" },
  { value: "professional", label: "Professional", desc: "Polished, business-ready", color: "text-indigo-600" },
  { value: "academic", label: "Academic", desc: "Formal, scholarly", color: "text-purple-600" },
  { value: "legal", label: "Legal", desc: "Precise, contractual", color: "text-slate-700" },
  { value: "persuasive", label: "Persuasive", desc: "Compelling, action-driven", color: "text-orange-600" },
  { value: "empathetic", label: "Empathetic", desc: "Validating, supportive", color: "text-pink-600" },
  { value: "concise", label: "Concise", desc: "Brief, direct", color: "text-teal-600" },
];

export default function ToneSelector({ value, onChange }) {
  const selected = TONES.find((t) => t.value === value) || TONES[2];

  return (
    <div className="relative">
      <label className="block text-sm font-medium text-slate-700 mb-1.5">
        Writing Tone
      </label>
      <div className="relative">
        <select
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="w-full appearance-none bg-white border border-slate-300 rounded-lg px-3 py-2.5 pr-10 text-sm focus:outline-none focus:ring-2 focus:ring-cyan-400 focus:border-cyan-400 cursor-pointer"
        >
          {TONES.map((tone) => (
            <option key={tone.value} value={tone.value}>
              {tone.label} — {tone.desc}
            </option>
          ))}
        </select>
        <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400 pointer-events-none" />
      </div>
      <p className={`mt-1 text-xs font-medium ${selected.color}`}>
        {selected.label}: {selected.desc}
      </p>
    </div>
  );
}

export { TONES };
